<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
      <v-toolbar-title>Oficinas</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="list-of-content" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title" @click="detailsContentAction(item)">
                {{item.oficina}}
                <span style="float:right;padding-right:15px;">{{language.view_details}}</span>
              </v-list-item-title>
              <v-list-item-subtitle v-html="item.content">

              </v-list-item-subtitle>
              <table
                class="list-of-content__details"
                v-bind:class="item.longitud !=='' && item.latitud !=='' ? ' mb-3' : 'has-btn '"
              >

                <tr v-if="item.telefono1 !==''">
                  <th>Teléfono</th>
                  <td>{{item.telefono1}}</td>
                </tr>

              </table>
              <div class="mb-2 mt-2 text-right">

                    </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
    <!-- <v-list two-line class="list-view" v-if="items.length > 0">
      <template v-for="(item) in items">
        <v-list-tile class="list-view-item" :key="item.title" avatar ripple>
          <v-list-tile-content>
            <v-list-tile-title :class="'pack-title'">{{ item.oficina }}</v-list-tile-title>

            <table
              v-bind:class="item.longitud !=='' && item.latitud !=='' ? 'pack-list-table mb-3' : 'has-btn pack-list-table'"
            >
              <tr>
                <th colspan="2">Direccion</th>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left;padding: 0px 15px 10px 16px;">
                  <v-list-tile-sub-title class="mt-3 no-hidden-text">{{ item.direccion }}</v-list-tile-sub-title>
                </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{item.email_address}}</td>
              </tr>
              <tr v-if="item.telefono1 !==''">
                <th>Telefono</th>
                <td>{{item.telefono1}}</td>
              </tr>
              <tr v-if="item.telefono2 !==''">
                <th>Telefono</th>
                <td>{{item.telefono2}}</td>
              </tr>
              <tr v-if="item.horario !==''">
                <th>Horario</th>
                <td>{{item.horario}}</td>
              </tr>
            </table>
            <v-btn
              color="info"
              class="mb-3 mt-1"
              block
              v-if="item.longitud !=='' && item.latitud !==''"
              @click="openMap(item.longitud,item.latitud,item.oficina)"
            >Ver en el mapa</v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>-->
    <div v-else>
       <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          NO TIENES DATOS DISPONIBLES
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" indeterminate class="loading-center"></v-progress-circular>
    </div>

    <v-dialog
      v-model="dialog_details"
      width="500"
    >
      <template>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{language.details}}
        </v-card-title>

        <v-card-text>

          <v-simple-table v-if="detailsContent != null">
            <template v-slot:default>
              <tbody>
                 <tr>
                  <th colspan="2">Dirección</th>
                </tr>
                <tr>
                  <td colspan="2">
                    <v-list-tile-sub-title class="mt-3 no-hidden-text">{{ detailsContent.direccion }}</v-list-tile-sub-title>
                  </td>
                </tr>
                <tr v-if="detailsContent.sector!=''">
                  <th>Sector</th>
                  <td>{{detailsContent.sector}}</td>
                </tr>
                <tr v-if="detailsContent.email_address !==''">
                  <th>Email</th>
                  <td>{{detailsContent.email_address}}</td>
                </tr>
                <tr v-if="detailsContent.telefono1 !==''">
                  <th>Teléfono</th>
                  <td>{{detailsContent.telefono1}}</td>
                </tr>
                <tr v-if="detailsContent.telefono2 !==''">
                  <th>Teléfono</th>
                  <td>{{detailsContent.telefono2}}</td>
                </tr>
                <tr v-if="detailsContent.horario !==''">
                  <th>Horario</th>
                  <td>{{detailsContent.horario}}</td>
                </tr>
                <tr v-if="detailsContent.instagram!=''">
                  <th>Instagram</th>
                  <td>{{detailsContent.instagram}}</td>
                </tr>
                <tr v-if="detailsContent.facebook!=''">
                  <th>Facebook</th>
                  <td>{{detailsContent.facebook}}</td>
                </tr>
                <tr v-if="detailsContent.twiiter">
                  <th>Twitter</th>
                  <td>{{detailsContent.twiiter}}</td>
                </tr>
                <tr v-if="detailsContent.website!=''">
                  <th>Website</th>
                  <td>{{detailsContent.website}}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <v-btn
                      color="info"
                      class="mb-3 mt-1"
                      block
                      v-if="detailsContent.longitud !=='' && detailsContent.latitud !==''"
                      @click="openMap(detailsContent.longitud,detailsContent.latitud,detailsContent.oficina)"
                    >Ver en el mapa</v-btn>
                  </td>
                </tr>

              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="detailsContentClose"
          >
            {{language.close}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>


</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      newValue => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      dialog_details:false,
      detailsContent:null
    };
  },
  computed: {
    login: function() {
      return this.$store.getters.login;
    },
    user: function() {
      return this.$store.getters.user;
    },
    language: function () {
      return this.$store.getters.language;
    }
  },
  methods: {
      detailsContentAction(details){
      this.dialog_details=true;
      this.detailsContent = details;
    },
    detailsContentClose(){
      this.dialog_details=false;
      this.detailsContent = null;
    },
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.office, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    }
  },
  name: "App"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
